module.exports = __webpack_public_path__ + "img/LADY HAT GREEN.3b37bce.svg";